// @ts-nocheck
import {Routes} from '@angular/router';
import entryvm5ur37i1k from '../../src/app/docs/categories/m-ui/ng-doc.category';
import entry72icp09xkxv from '../../src/app/docs/categories/angular-materiel/ng-doc.category';
import entry0speyf5sfvtq from '../../src/app/docs/categories/m-service/ng-doc.category';
import entryzcl9x8qy99 from '../../src/app/docs/categories/getting-started/ng-doc.category';
import entrycullr09gr4l from '../../src/app/docs/categories/m-theme/ng-doc.category';

export const NG_DOC_ROUTING: Routes = [
	
	{
		path: 'api',
		title: `API`,
		loadChildren: () => import('./api/page'),
	},
	
	{
		path: 'api/classes/m-ui/MAceEditor',
		title: `MAceEditor`,
		loadChildren: () => import('./api/api/classes/m-ui/MAceEditor/page'),
	},
	
	{
		path: 'api/type-aliases/m-ui/AffluenceLevel',
		title: `AffluenceLevel`,
		loadChildren: () => import('./api/api/type-aliases/m-ui/AffluenceLevel/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/AffluenceData',
		title: `AffluenceData`,
		loadChildren: () => import('./api/api/interfaces/m-ui/AffluenceData/page'),
	},
	
	{
		path: 'api/classes/m-ui/MAffluence',
		title: `MAffluence`,
		loadChildren: () => import('./api/api/classes/m-ui/MAffluence/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/AppDownload',
		title: `AppDownload`,
		loadChildren: () => import('./api/api/interfaces/m-ui/AppDownload/page'),
	},
	
	{
		path: 'api/classes/m-ui/MAppDownload',
		title: `MAppDownload`,
		loadChildren: () => import('./api/api/classes/m-ui/MAppDownload/page'),
	},
	
	{
		path: 'api/classes/m-ui/MBadgeDirective',
		title: `MBadgeDirective`,
		loadChildren: () => import('./api/api/classes/m-ui/MBadgeDirective/page'),
	},
	
	{
		path: 'api/type-aliases/m-ui/MBadgePositionType',
		title: `MBadgePositionType`,
		loadChildren: () => import('./api/api/type-aliases/m-ui/MBadgePositionType/page'),
	},
	
	{
		path: 'api/type-aliases/m-ui/MBadgeType',
		title: `MBadgeType`,
		loadChildren: () => import('./api/api/type-aliases/m-ui/MBadgeType/page'),
	},
	
	{
		path: 'api/enums/m-ui/MBadgesTypes',
		title: `MBadgesTypes`,
		loadChildren: () => import('./api/api/enums/m-ui/MBadgesTypes/page'),
	},
	
	{
		path: 'api/enums/m-ui/MBadgesPosition',
		title: `MBadgesPosition`,
		loadChildren: () => import('./api/api/enums/m-ui/MBadgesPosition/page'),
	},
	
	{
		path: 'api/enums/m-ui/MBottomBarPosition',
		title: `MBottomBarPosition`,
		loadChildren: () => import('./api/api/enums/m-ui/MBottomBarPosition/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/MBottomBarItem',
		title: `MBottomBarItem`,
		loadChildren: () => import('./api/api/interfaces/m-ui/MBottomBarItem/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/MBottomBarBadge',
		title: `MBottomBarBadge`,
		loadChildren: () => import('./api/api/interfaces/m-ui/MBottomBarBadge/page'),
	},
	
	{
		path: 'api/classes/m-ui/MBottomBar',
		title: `MBottomBar`,
		loadChildren: () => import('./api/api/classes/m-ui/MBottomBar/page'),
	},
	
	{
		path: 'api/classes/m-ui/MBottomBarService',
		title: `MBottomBarService`,
		loadChildren: () => import('./api/api/classes/m-ui/MBottomBarService/page'),
	},
	
	{
		path: 'api/classes/m-ui/MButtonLink',
		title: `MButtonLink`,
		loadChildren: () => import('./api/api/classes/m-ui/MButtonLink/page'),
	},
	
	{
		path: 'api/classes/m-ui/MDisturbance',
		title: `MDisturbance`,
		loadChildren: () => import('./api/api/classes/m-ui/MDisturbance/page'),
	},
	
	{
		path: 'api/type-aliases/m-ui/DisturbanceLevel',
		title: `DisturbanceLevel`,
		loadChildren: () => import('./api/api/type-aliases/m-ui/DisturbanceLevel/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/DisturbanceData',
		title: `DisturbanceData`,
		loadChildren: () => import('./api/api/interfaces/m-ui/DisturbanceData/page'),
	},
	
	{
		path: 'api/functions/m-ui/openMEventDialog',
		title: `openMEventDialog`,
		loadChildren: () => import('./api/api/functions/m-ui/openMEventDialog/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/ActionButton',
		title: `ActionButton`,
		loadChildren: () => import('./api/api/interfaces/m-ui/ActionButton/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/MEventDialogEvent',
		title: `MEventDialogEvent`,
		loadChildren: () => import('./api/api/interfaces/m-ui/MEventDialogEvent/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/MEventDialogData',
		title: `MEventDialogData`,
		loadChildren: () => import('./api/api/interfaces/m-ui/MEventDialogData/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/MEventDialogResult',
		title: `MEventDialogResult`,
		loadChildren: () => import('./api/api/interfaces/m-ui/MEventDialogResult/page'),
	},
	
	{
		path: 'api/classes/m-ui/MEventDialog',
		title: `MEventDialog`,
		loadChildren: () => import('./api/api/classes/m-ui/MEventDialog/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/FileSystemEntry',
		title: `FileSystemEntry`,
		loadChildren: () => import('./api/api/interfaces/m-ui/FileSystemEntry/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/FileSystemEntryMetadata',
		title: `FileSystemEntryMetadata`,
		loadChildren: () => import('./api/api/interfaces/m-ui/FileSystemEntryMetadata/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/FileSystemDirectoryReader',
		title: `FileSystemDirectoryReader`,
		loadChildren: () => import('./api/api/interfaces/m-ui/FileSystemDirectoryReader/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/FileSystemFlags',
		title: `FileSystemFlags`,
		loadChildren: () => import('./api/api/interfaces/m-ui/FileSystemFlags/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/FileSystemDirectoryEntry',
		title: `FileSystemDirectoryEntry`,
		loadChildren: () => import('./api/api/interfaces/m-ui/FileSystemDirectoryEntry/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/FileSystemFileEntry',
		title: `FileSystemFileEntry`,
		loadChildren: () => import('./api/api/interfaces/m-ui/FileSystemFileEntry/page'),
	},
	
	{
		path: 'api/classes/m-ui/FileDropContentTemplateDirective',
		title: `FileDropContentTemplateDirective`,
		loadChildren: () => import('./api/api/classes/m-ui/FileDropContentTemplateDirective/page'),
	},
	
	{
		path: 'api/classes/m-ui/MFilesDrop',
		title: `MFilesDrop`,
		loadChildren: () => import('./api/api/classes/m-ui/MFilesDrop/page'),
	},
	
	{
		path: 'api/classes/m-ui/FilesDropEntry',
		title: `FilesDropEntry`,
		loadChildren: () => import('./api/api/classes/m-ui/FilesDropEntry/page'),
	},
	
	{
		path: 'api/type-aliases/m-ui/IconVariant',
		title: `IconVariant`,
		loadChildren: () => import('./api/api/type-aliases/m-ui/IconVariant/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/IconType',
		title: `IconType`,
		loadChildren: () => import('./api/api/interfaces/m-ui/IconType/page'),
	},
	
	{
		path: 'api/classes/m-ui/MIcon',
		title: `MIcon`,
		loadChildren: () => import('./api/api/classes/m-ui/MIcon/page'),
	},
	
	{
		path: 'api/classes/m-ui/IconRegistryService',
		title: `IconRegistryService`,
		loadChildren: () => import('./api/api/classes/m-ui/IconRegistryService/page'),
	},
	
	{
		path: 'api/functions/m-ui/provideMIcons',
		title: `provideMIcons`,
		loadChildren: () => import('./api/api/functions/m-ui/provideMIcons/page'),
	},
	
	{
		path: 'api/classes/m-ui/MIconButton',
		title: `MIconButton`,
		loadChildren: () => import('./api/api/classes/m-ui/MIconButton/page'),
	},
	
	{
		path: 'api/variables/m-ui/ICONS',
		title: `ICONS`,
		loadChildren: () => import('./api/api/variables/m-ui/ICONS/page'),
	},
	
	{
		path: 'api/classes/m-ui/MIcons',
		title: `MIcons`,
		loadChildren: () => import('./api/api/classes/m-ui/MIcons/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/IconMapping',
		title: `IconMapping`,
		loadChildren: () => import('./api/api/interfaces/m-ui/IconMapping/page'),
	},
	
	{
		path: 'api/classes/m-ui/MIconsService',
		title: `MIconsService`,
		loadChildren: () => import('./api/api/classes/m-ui/MIconsService/page'),
	},
	
	{
		path: 'api/functions/m-ui/provideMIconsConfig',
		title: `provideMIconsConfig`,
		loadChildren: () => import('./api/api/functions/m-ui/provideMIconsConfig/page'),
	},
	
	{
		path: 'api/variables/m-ui/DOMAIN',
		title: `DOMAIN`,
		loadChildren: () => import('./api/api/variables/m-ui/DOMAIN/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/MIconsConfig',
		title: `MIconsConfig`,
		loadChildren: () => import('./api/api/interfaces/m-ui/MIconsConfig/page'),
	},
	
	{
		path: 'api/classes/m-ui/MItem',
		title: `MItem`,
		loadChildren: () => import('./api/api/classes/m-ui/MItem/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/MItemType',
		title: `MItemType`,
		loadChildren: () => import('./api/api/interfaces/m-ui/MItemType/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/MItemDescription',
		title: `MItemDescription`,
		loadChildren: () => import('./api/api/interfaces/m-ui/MItemDescription/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/MItemsRight',
		title: `MItemsRight`,
		loadChildren: () => import('./api/api/interfaces/m-ui/MItemsRight/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/MItemsLeft',
		title: `MItemsLeft`,
		loadChildren: () => import('./api/api/interfaces/m-ui/MItemsLeft/page'),
	},
	
	{
		path: 'api/enums/m-ui/MItemTypes',
		title: `MItemTypes`,
		loadChildren: () => import('./api/api/enums/m-ui/MItemTypes/page'),
	},
	
	{
		path: 'api/enums/m-ui/MItemEnumType',
		title: `MItemEnumType`,
		loadChildren: () => import('./api/api/enums/m-ui/MItemEnumType/page'),
	},
	
	{
		path: 'api/enums/m-ui/MListEnumType',
		title: `MListEnumType`,
		loadChildren: () => import('./api/api/enums/m-ui/MListEnumType/page'),
	},
	
	{
		path: 'api/enums/m-ui/MListPosition',
		title: `MListPosition`,
		loadChildren: () => import('./api/api/enums/m-ui/MListPosition/page'),
	},
	
	{
		path: 'api/classes/m-ui/MItemCustom',
		title: `MItemCustom`,
		loadChildren: () => import('./api/api/classes/m-ui/MItemCustom/page'),
	},
	
	{
		path: 'api/classes/m-ui/MListWrapper',
		title: `MListWrapper`,
		loadChildren: () => import('./api/api/classes/m-ui/MListWrapper/page'),
	},
	
	{
		path: 'api/classes/m-ui/MFadeInDirective',
		title: `MFadeInDirective`,
		loadChildren: () => import('./api/api/classes/m-ui/MFadeInDirective/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/MListWrapperListConfig',
		title: `MListWrapperListConfig`,
		loadChildren: () => import('./api/api/interfaces/m-ui/MListWrapperListConfig/page'),
	},
	
	{
		path: 'api/type-aliases/m-ui/LogoLineShape',
		title: `LogoLineShape`,
		loadChildren: () => import('./api/api/type-aliases/m-ui/LogoLineShape/page'),
	},
	
	{
		path: 'api/type-aliases/m-ui/LogoLineSize',
		title: `LogoLineSize`,
		loadChildren: () => import('./api/api/type-aliases/m-ui/LogoLineSize/page'),
	},
	
	{
		path: 'api/type-aliases/m-ui/LogoLineType',
		title: `LogoLineType`,
		loadChildren: () => import('./api/api/type-aliases/m-ui/LogoLineType/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/LogoLine',
		title: `LogoLine`,
		loadChildren: () => import('./api/api/interfaces/m-ui/LogoLine/page'),
	},
	
	{
		path: 'api/classes/m-ui/MLogoLine',
		title: `MLogoLine`,
		loadChildren: () => import('./api/api/classes/m-ui/MLogoLine/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/Line',
		title: `Line`,
		loadChildren: () => import('./api/api/interfaces/m-ui/Line/page'),
	},
	
	{
		path: 'api/enums/m-ui/Shape',
		title: `Shape`,
		loadChildren: () => import('./api/api/enums/m-ui/Shape/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/disturbanceInfo',
		title: `disturbanceInfo`,
		loadChildren: () => import('./api/api/interfaces/m-ui/disturbanceInfo/page'),
	},
	
	{
		path: 'api/classes/m-ui/MLogoLines',
		title: `MLogoLines`,
		loadChildren: () => import('./api/api/classes/m-ui/MLogoLines/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/MNotificationInterface',
		title: `MNotificationInterface`,
		loadChildren: () => import('./api/api/interfaces/m-ui/MNotificationInterface/page'),
	},
	
	{
		path: 'api/classes/m-ui/MNotifications',
		title: `MNotifications`,
		loadChildren: () => import('./api/api/classes/m-ui/MNotifications/page'),
	},
	
	{
		path: 'api/classes/m-ui/MProgressSpinner',
		title: `MProgressSpinner`,
		loadChildren: () => import('./api/api/classes/m-ui/MProgressSpinner/page'),
	},
	
	{
		path: 'api/classes/m-ui/MTable',
		title: `MTable`,
		loadChildren: () => import('./api/api/classes/m-ui/MTable/page'),
	},
	
	{
		path: 'api/enums/m-ui/HeaderTypes',
		title: `HeaderTypes`,
		loadChildren: () => import('./api/api/enums/m-ui/HeaderTypes/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/HeaderTable',
		title: `HeaderTable`,
		loadChildren: () => import('./api/api/interfaces/m-ui/HeaderTable/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/HeaderTableSelectOptions',
		title: `HeaderTableSelectOptions`,
		loadChildren: () => import('./api/api/interfaces/m-ui/HeaderTableSelectOptions/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/HeaderTableOptions',
		title: `HeaderTableOptions`,
		loadChildren: () => import('./api/api/interfaces/m-ui/HeaderTableOptions/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/ConfigTableCustom',
		title: `ConfigTableCustom`,
		loadChildren: () => import('./api/api/interfaces/m-ui/ConfigTableCustom/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/ConfigActionTable',
		title: `ConfigActionTable`,
		loadChildren: () => import('./api/api/interfaces/m-ui/ConfigActionTable/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/ActionTable',
		title: `ActionTable`,
		loadChildren: () => import('./api/api/interfaces/m-ui/ActionTable/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/ConfigTable',
		title: `ConfigTable`,
		loadChildren: () => import('./api/api/interfaces/m-ui/ConfigTable/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/ConfigButtonTable',
		title: `ConfigButtonTable`,
		loadChildren: () => import('./api/api/interfaces/m-ui/ConfigButtonTable/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/FilterText',
		title: `FilterText`,
		loadChildren: () => import('./api/api/interfaces/m-ui/FilterText/page'),
	},
	
	{
		path: 'api/classes/m-ui/RelativeDatePipe',
		title: `RelativeDatePipe`,
		loadChildren: () => import('./api/api/classes/m-ui/RelativeDatePipe/page'),
	},
	
	{
		path: 'api/classes/m-ui/MTabsHeader',
		title: `MTabsHeader`,
		loadChildren: () => import('./api/api/classes/m-ui/MTabsHeader/page'),
	},
	
	{
		path: 'api/classes/m-ui/MTag',
		title: `MTag`,
		loadChildren: () => import('./api/api/classes/m-ui/MTag/page'),
	},
	
	{
		path: 'api/type-aliases/m-ui/TagSize',
		title: `TagSize`,
		loadChildren: () => import('./api/api/type-aliases/m-ui/TagSize/page'),
	},
	
	{
		path: 'api/type-aliases/m-ui/TagSeverity',
		title: `TagSeverity`,
		loadChildren: () => import('./api/api/type-aliases/m-ui/TagSeverity/page'),
	},
	
	{
		path: 'api/classes/m-ui/MThemeToggle',
		title: `MThemeToggle`,
		loadChildren: () => import('./api/api/classes/m-ui/MThemeToggle/page'),
	},
	
	{
		path: 'api/enums/m-ui/THEME',
		title: `THEME`,
		loadChildren: () => import('./api/api/enums/m-ui/THEME/page'),
	},
	
	{
		path: 'api/enums/m-ui/THEME_MODE',
		title: `THEME_MODE`,
		loadChildren: () => import('./api/api/enums/m-ui/THEME_MODE/page'),
	},
	
	{
		path: 'api/classes/m-ui/MThemeToggleService',
		title: `MThemeToggleService`,
		loadChildren: () => import('./api/api/classes/m-ui/MThemeToggleService/page'),
	},
	
	{
		path: 'api/classes/m-ui/MToolbar',
		title: `MToolbar`,
		loadChildren: () => import('./api/api/classes/m-ui/MToolbar/page'),
	},
	
	{
		path: 'api/classes/m-ui/NormalizeToolbarActionsPipe',
		title: `NormalizeToolbarActionsPipe`,
		loadChildren: () => import('./api/api/classes/m-ui/NormalizeToolbarActionsPipe/page'),
	},
	
	{
		path: 'api/classes/m-ui/MToolbarService',
		title: `MToolbarService`,
		loadChildren: () => import('./api/api/classes/m-ui/MToolbarService/page'),
	},
	
	{
		path: 'api/variables/m-ui/ICONS_MAPPING_CUSTOMS',
		title: `ICONS_MAPPING_CUSTOMS`,
		loadChildren: () => import('./api/api/variables/m-ui/ICONS_MAPPING_CUSTOMS/page'),
	},
	
	{
		path: 'api/variables/m-ui/ICONS_MAPPING_MATERIAL',
		title: `ICONS_MAPPING_MATERIAL`,
		loadChildren: () => import('./api/api/variables/m-ui/ICONS_MAPPING_MATERIAL/page'),
	},
	
	{
		path: 'api/interfaces/m-ui/ToolbarAction',
		title: `ToolbarAction`,
		loadChildren: () => import('./api/api/interfaces/m-ui/ToolbarAction/page'),
	},
	
	{
		path: 'm-ui',
		title: `M-ui`,
    providers: [
      ...(entryvm5ur37i1k.providers ?? []),
    ],
		children: [{
			path: '',
			redirectTo: 'm-affluence',
			pathMatch: 'full'
		},
	{
		path: 'm-affluence',
		title: `M-affluence`,
		loadChildren: () => import('./guides/m-ui/m-affluence/page'),
	},
	{
		path: 'm-ace-editor',
		title: `M-ace-editor`,
		loadChildren: () => import('./guides/m-ui/m-ace-editor/page'),
	},
	{
		path: 'm-button-link',
		title: `M-button-link`,
		loadChildren: () => import('./guides/m-ui/m-button-link/page'),
	},
	{
		path: 'm-icon-buton',
		title: `M-icon-button`,
		loadChildren: () => import('./guides/m-ui/m-icon-buton/page'),
	},
	{
		path: 'm-disturbance-display',
		title: `M-disturbance-display`,
		loadChildren: () => import('./guides/m-ui/m-disturbance-display/page'),
	},
	{
		path: 'm-badges',
		title: `M-badges`,
		loadChildren: () => import('./guides/m-ui/m-badges/page'),
	},
	{
		path: 'm-theme-toggle',
		title: `M-theme-toggle`,
		loadChildren: () => import('./guides/m-ui/m-theme-toggle/page'),
	},
	{
		path: 'm-list-wrapper',
		title: `M-list-wrapper`,
		loadChildren: () => import('./guides/m-ui/m-list-wrapper/page'),
	},
	{
		path: 'm-list',
		title: `M-list`,
		loadChildren: () => import('./guides/m-ui/m-list/page'),
	},
	{
		path: 'm-bottom-bar',
		title: `M-bottom-bar`,
		loadChildren: () => import('./guides/m-ui/m-bottom-bar/page'),
	},
	{
		path: 'm-icons',
		title: `M-icons`,
		loadChildren: () => import('./guides/m-ui/m-icons/page'),
	},
	{
		path: 'm-event-dialog',
		title: `M-event-dialog`,
		loadChildren: () => import('./guides/m-ui/m-event-dialog/page'),
	},
	{
		path: 'm-logo-lines',
		title: `M-logo-lines`,
		loadChildren: () => import('./guides/m-ui/m-logo-lines/page'),
	},
	{
		path: 'm-notifications',
		title: `M-notifications`,
		loadChildren: () => import('./guides/m-ui/m-notifications/page'),
	},
	{
		path: 'm-toolbar',
		title: `M-toolbar`,
		loadChildren: () => import('./guides/m-ui/m-toolbar/page'),
	},
	{
		path: 'm-etiquette',
		title: `M-etiquette`,
		loadChildren: () => import('./guides/m-ui/m-etiquette/page'),
	},
	{
		path: 'm-table',
		title: `M-table`,
		loadChildren: () => import('./guides/m-ui/m-table/page'),
	},
	{
		path: 'm-scroll',
		title: `M-scroll`,
		loadChildren: () => import('./guides/m-ui/m-scroll/page'),
	},
	{
		path: 'm-progress-spinner',
		title: `M-progress-spinner`,
		loadChildren: () => import('./guides/m-ui/m-progress-spinner/page'),
	},
	{
		path: 'm-drop-files',
		title: `M-drop-files`,
		loadChildren: () => import('./guides/m-ui/m-drop-files/page'),
	},
	{
		path: 'm-app-download',
		title: `M-app-download`,
		loadChildren: () => import('./guides/m-ui/m-app-download/page'),
	},],
	},
	
	{
		path: 'angular-materiel',
		title: `Angular-material`,
    providers: [
      ...(entry72icp09xkxv.providers ?? []),
    ],
		children: [{
			path: '',
			redirectTo: 'material-card',
			pathMatch: 'full'
		},
	{
		path: 'material-card',
		title: `Card`,
		loadChildren: () => import('./guides/angular-material/material-card/page'),
	},
	{
		path: 'material-ripples',
		title: `Ripples`,
		loadChildren: () => import('./guides/angular-material/material-ripples/page'),
	},
	{
		path: 'material-select',
		title: `Select`,
		loadChildren: () => import('./guides/angular-material/material-select/page'),
	},
	{
		path: 'material-sidenav',
		title: `Sidenav`,
		loadChildren: () => import('./guides/angular-material/material-sidenav/page'),
	},
	{
		path: 'material-radio',
		title: `Radio`,
		loadChildren: () => import('./guides/angular-material/material-radio/page'),
	},
	{
		path: 'material-progress-bar',
		title: `Progress bar`,
		loadChildren: () => import('./guides/angular-material/material-progress-bar/page'),
	},
	{
		path: 'material-stepper',
		title: `Stepper`,
		loadChildren: () => import('./guides/angular-material/material-stepper/page'),
	},
	{
		path: 'material-snackbar',
		title: `Snackbar`,
		loadChildren: () => import('./guides/angular-material/material-snackbar/page'),
	},
	{
		path: 'material-slider',
		title: `Slider`,
		loadChildren: () => import('./guides/angular-material/material-slider/page'),
	},
	{
		path: 'material-slide-toggle',
		title: `Slide toggle`,
		loadChildren: () => import('./guides/angular-material/material-slide-toggle/page'),
	},
	{
		path: 'material-tree',
		title: `Tree`,
		loadChildren: () => import('./guides/angular-material/material-tree/page'),
	},
	{
		path: 'material-sort-header',
		title: `Sort header`,
		loadChildren: () => import('./guides/angular-material/material-sort-header/page'),
	},
	{
		path: 'material-toolbar',
		title: `Toolbar`,
		loadChildren: () => import('./guides/angular-material/material-toolbar/page'),
	},
	{
		path: 'material-tooltip',
		title: `Tooltip`,
		loadChildren: () => import('./guides/angular-material/material-tooltip/page'),
	},
	{
		path: 'material-tabs',
		title: `Tabs`,
		loadChildren: () => import('./guides/angular-material/material-tabs/page'),
	},
	{
		path: 'material-datepicker',
		title: `Datepicker`,
		loadChildren: () => import('./guides/angular-material/material-datepicker/page'),
	},
	{
		path: 'material-dialog',
		title: `Dialog`,
		loadChildren: () => import('./guides/angular-material/material-dialog/page'),
	},
	{
		path: 'material-chips',
		title: `Chips`,
		loadChildren: () => import('./guides/angular-material/material-chips/page'),
	},
	{
		path: 'material-list',
		title: `List`,
		loadChildren: () => import('./guides/angular-material/material-list/page'),
	},
	{
		path: 'material-expansion-panel',
		title: `Expansion Panel`,
		loadChildren: () => import('./guides/angular-material/material-expansion-panel/page'),
	},
	{
		path: 'material-form-field',
		title: `Form field`,
		loadChildren: () => import('./guides/angular-material/material-form-field/page'),
	},
	{
		path: 'material-badge',
		title: `Badge`,
		loadChildren: () => import('./guides/angular-material/material-badge/page'),
	},
	{
		path: 'material-autocomplete',
		title: `Autocomplete`,
		loadChildren: () => import('./guides/angular-material/material-autocomplete/page'),
	},
	{
		path: 'material-bottom-sheet',
		title: `Bottom-sheet`,
		loadChildren: () => import('./guides/angular-material/material-bottom-sheet/page'),
	},
	{
		path: 'material-checkbox',
		title: `Checkbox`,
		loadChildren: () => import('./guides/angular-material/material-checkbox/page'),
	},
	{
		path: 'material-input',
		title: `Input`,
		loadChildren: () => import('./guides/angular-material/material-input/page'),
	},
	{
		path: 'material-timepicker',
		title: `Timepicker`,
		loadChildren: () => import('./guides/angular-material/material-timepicker/page'),
	},
	{
		path: 'material-table',
		title: `Table`,
		loadChildren: () => import('./guides/angular-material/material-table/page'),
	},
	{
		path: 'material-button',
		title: `Button`,
		loadChildren: () => import('./guides/angular-material/material-button/page'),
	},
	{
		path: 'material-button-toggle',
		title: `Button-toggle`,
		loadChildren: () => import('./guides/angular-material/material-button-toggle/page'),
	},
	{
		path: 'material-divider',
		title: `Divider`,
		loadChildren: () => import('./guides/angular-material/material-divider/page'),
	},
	{
		path: 'material-progress-spinner',
		title: `Progress spinner`,
		loadChildren: () => import('./guides/angular-material/material-progress-spinner/page'),
	},],
	},
	
	{
		path: 'm-service',
		title: `M-Tools`,
    providers: [
      ...(entry0speyf5sfvtq.providers ?? []),
    ],
		children: [{
			path: '',
			redirectTo: 'm-error-service',
			pathMatch: 'full'
		},
	{
		path: 'm-error-service',
		title: `M-error-service (SERVICE)`,
		loadChildren: () => import('./guides/m-service/m-error-service/page'),
	},
	{
		path: 'm-providers',
		title: `M-providers`,
		loadChildren: () => import('./guides/m-service/m-providers/page'),
	},
	{
		path: 'm-files',
		title: `M-files`,
		loadChildren: () => import('./guides/m-service/m-files/page'),
	},
	{
		path: 'm-url-utils',
		title: `M-url-utils`,
		loadChildren: () => import('./guides/m-service/m-url-utils/page'),
	},],
	},
	
	{
		path: 'getting-started',
		title: `Getting Started`,
    providers: [
      ...(entryzcl9x8qy99.providers ?? []),
    ],
		children: [{
			path: '',
			redirectTo: 'docs',
			pathMatch: 'full'
		},
	{
		path: 'docs',
		title: `Docs`,
		loadChildren: () => import('./guides/started/docs/page'),
	},
	{
		path: 'changelog',
		title: `Changelog`,
		loadChildren: () => import('./guides/started/changelog/page'),
	},
	{
		path: 'install',
		title: `Install`,
		loadChildren: () => import('./guides/started/install/page'),
	},
	{
		path: 'migration',
		title: `Migration`,
		loadChildren: () => import('./guides/started/migration/page'),
	},
	{
		path: 'usage',
		title: `Usage`,
		loadChildren: () => import('./guides/started/usage/page'),
	},
	{
		path: 'what-is',
		title: `What is`,
		loadChildren: () => import('./guides/started/what-is/page'),
	},
	{
		path: 'peer-dependency',
		title: `Peer dependency`,
		loadChildren: () => import('./guides/started/peer-dependency/page'),
	},],
	},
	
	{
		path: 'm-theme',
		title: `Mtheme`,
    providers: [
      ...(entrycullr09gr4l.providers ?? []),
    ],
		children: [{
			path: '',
			redirectTo: 'typography',
			pathMatch: 'full'
		},
	{
		path: 'typography',
		title: `Typography`,
		loadChildren: () => import('./guides/theming/typography/page'),
	},
	{
		path: 'colors',
		title: `Colors`,
		loadChildren: () => import('./guides/theming/colors/page'),
	},
	{
		path: 'classes',
		title: `Classes`,
		loadChildren: () => import('./guides/theming/classes/page'),
	},
	{
		path: 'elevation',
		title: `Elevation`,
		loadChildren: () => import('./guides/theming/elevation/page'),
	},
	{
		path: 'corner',
		title: `Shapes/Radius`,
		loadChildren: () => import('./guides/theming/corner/page'),
	},
	{
		path: 'breakpoints',
		title: `Breakpoints`,
		loadChildren: () => import('./guides/theming/breakpoints/page'),
	},
	{
		path: 'other-variables',
		title: `Other Variables`,
		loadChildren: () => import('./guides/theming/other-variables/page'),
	},
	{
		path: 'spacing',
		title: `Spacing`,
		loadChildren: () => import('./guides/theming/spacing/page'),
	},],
	},
];
